module.exports = __webpack_public_path__ + "static/media/100.2abca9f5.png";